/**
 * @generated SignedSource<<031ebde1ae13148dfb48d6ae49353983>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PublishState = "ARCHIVED" | "DELETED" | "DRAFT" | "PUBLISHED" | "%future added value";
export type TodoState = "CHECKED" | "DISMISSED" | "UNCHECKED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PageEditor_node$data = {
  readonly canRename?: {
    readonly value: boolean;
  };
  readonly canUpdate?: {
    readonly value: boolean;
  };
  readonly content?: {
    readonly __typename: "Page";
    readonly data: UnknownJSON | null;
    readonly id: string;
    readonly title: string;
    readonly todos: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "Todo";
          readonly assignee: {
            readonly id: string;
          } | null;
          readonly documentNode: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"TodoCard_page">;
          };
          readonly dueDate: DateString  | null;
          readonly id: string;
          readonly isListed: boolean;
          readonly publishState: PublishState;
          readonly state: TodoState;
          readonly text: UnknownJSON | null;
          readonly " $fragmentSpreads": FragmentRefs<"TodoAssignee_todo" | "TodoDueDate_todo">;
        } | null;
      }>;
    } | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly id?: string;
  readonly name?: string;
  readonly publishState?: PublishState;
  readonly space?: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"FolderNodePublishBar_folderNode" | "PublishReminderDialog_folderItem">;
  readonly " $fragmentType": "PageEditor_node";
};
export type PageEditor_node$key = {
  readonly " $data"?: PageEditor_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageEditor_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishState",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageEditor_node",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FolderNodePublishBar_folderNode"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canRename",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthorizationResult",
          "kind": "LinkedField",
          "name": "canUpdate",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "data",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 500
                    }
                  ],
                  "concreteType": "TodoConnection",
                  "kind": "LinkedField",
                  "name": "todos",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TodoEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Todo",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v3/*: any*/),
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TodoDueDate_todo"
                            },
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "TodoAssignee_todo"
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "text",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FolderItem",
                              "kind": "LinkedField",
                              "name": "documentNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "args": null,
                                  "kind": "FragmentSpread",
                                  "name": "TodoCard_page"
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Member",
                              "kind": "LinkedField",
                              "name": "assignee",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "state",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "dueDate",
                              "storageKey": null
                            },
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isListed",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "todos(first:500)"
                }
              ],
              "type": "Page",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PublishReminderDialog_folderItem"
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "a05a63a8ecad37ee027f68dda4369bbd";

export default node;
